import React from 'react'

const OrderReportCard = (props) => {

    const reportId = props.reportId;
    const reportName = props.reportName;
    const reportFrequency = props.frequencyDays;
    const includeOrdersFrom = props.includeOrdersFromDays;
    const selectedOrderStatuses = props.orderStatuses;
    const showDeleteAction = props.showDeleteAction;

    const reportFrequencyOptions = props.reportFrequencyOptions || [];
    const includeOrdersFromOptions = props.includeOrdersFromOptions || [];
    const statusOptions = props.statusOptions || [];

    return (
        <div className='order-report-details-wrapper py-2 px-3 border border-secondary mt-4 mb-4 rounded'>
            <div className="schedule-report-detauls-header">
                <p><strong>{ reportName }</strong></p>
                {
                    showDeleteAction && (
                        <span className="delete-report-action" onClick={() => props.deleteReportHandler(reportId)}>
                            <i className="fa fa-lg fa-trash"></i>
                        </span>
                    )
                }
            </div>

            <div className='schedule-report-row d-flex align-items-center gap-4 mb-3'>
                <div className='d-flex align-items-center gap-2'>
                    <i className="m-0 d-flex align-items-center fa fa-lg fa-calendar"></i>
                    <p className='m-0'>{ reportFrequencyOptions.find(option => option.key === reportFrequency)?.slug }</p>
                </div>

                <div className='d-flex align-items-center gap-2'>
                    <i className="m-0 d-flex align-items-center fa fa-lg fa-clock-o"></i>
                    <p className='m-0'>Orders from the { includeOrdersFromOptions.find(option => option.key === includeOrdersFrom)?.slug?.toLowerCase() }</p>
                </div>
            </div>

            <div className='schedule-report-row d-flex align-items-center gap-4'>
                <div className='d-flex align-items-center gap-2'>
                    <i className="m-0 d-flex align-items-center fa fa-lg fa-flag"></i>
                    <p className='m-0 text-secondary'>{ selectedOrderStatuses.map(value => { return statusOptions.find(option => option.key === value)?.slug }).join(', ') }</p>
                </div>
            </div>
        </div>
    )
}

export default OrderReportCard
